import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class TAStrategyProxy extends ProxyBase {
  getAccumulation(params) {
    return this.get('GetAccumulation', params);
  }
  getBreakout(params) {
    return this.get('GetBreakout', params);
  }
  getBreakoutMa(params) {
    return this.get('GetBreakoutMa', params);
  }
  getBestInDownTrend(params) {
    return this.get('GetBestInDownTrend', params);
  }
  getMarketAnomaly(params) {
    return this.get('GetMarketAnomaly', params);
  }
}

const taStrategyProxy = new TAStrategyProxy(
  ServiceProxyConfig.TAStategy.ServiceUrl,
);
export default taStrategyProxy;
